import styled from 'styled-components'

import { IconClear } from '@avantstay/backoffice-vectors'

import { InputProps } from './__types'

export const Root = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  > svg {
    flex-shrink: 0;
    flex-grow: 0;
  }
`

export const Input = styled.input<InputProps>`
  background: ${props => props.backgroundColor};
  color: ${props => props.baseColor};
  font-size: ${props => props.fontSize};
  padding-left: ${props => props.spaceAfterIcon};
  border: none;
  outline: none;
  flex-grow: 1;

  &::placeholder {
    font-size: ${props => props.fontSize};
    color: ${props => props.placeholderColor || 'rgba(255, 255, 255, 0.3)'};
  }
`

export const ClearButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  display: flex;
`

export const ClearButtonIcon = styled(IconClear)<{ fill?: string }>`
  fill: ${props => props.fill};
`
